import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavBarButton from "../buttons/NavBarButton";
import Space from "../layout/Space";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgByRef } from "../models/OrgFunctions";
import PrimaryButton from "../buttons/PrimaryButton";
import { Switch } from "@mui/material";
import { useAppContext } from "../config/AppContext";
import TextFieldMicro from "../textfields/TextFieldMicro";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  last_of_list,
} from "../models/DataFunctions";
import DropDownOrg from "../dropdowns/DropDownOrg";
import Icon1 from "../icons/Icon";

import { useSnackbar } from "notistack";
import { particulierActivated } from "../hexagone/VisibilityHelpers";
function NavPortal({ orgData, actualpage, navigateWorkspace, handleLogout }) {
  const { currentUser, loading } = useAuth();
  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [userData, setUserData] = useState(null);
  const [folderData, setFolderData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [url, setUrl] = useState("http://127.0.0.1:8000/");
  const [payments, setPayments] = useState([]);
  const [masterData, setMasterData] = useState(null);
  const [reglementData, setReglementData] = useState(null);
  const [noAvailablePayment, setNoAvailablePayment] = useState(false);
  const openCallMenu = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const setNewMasterData = async (data) => {
    setMasterData(data);
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        let path = location.pathname;
        let id = path.split("/").pop();

        if (path.includes("/imp-portal/") && !orgData) {
          return;
        }

        let type = path.includes("/imp-portal/folder")
          ? "folder"
          : path.includes("/imp-portal/rapport")
            ? "payment"
            : currentUser.uid.split("-")[1];
        let item_id = path.includes("/imp-portal/")
          ? id
          : currentUser.uid.split("-")[2];

        // uuid is "guest-folder-{data.id}---"uuid
        let master;

        if (type === "payment") {
          let payment_id = item_id;
          const payment = await getDocDataById("payment", payment_id);
          type = "folder";
          item_id = payment.folder_ref.id;
        }

        if (type === "folder") {
          const folder_id = item_id;
          const folder = await getDocDataById("folder", folder_id);
          master = await getOrgDataById(folder.master_id);
          let ref = folder.invoices?.find((inv) => inv.is_devis)?.ref;
          if (ref) {
            const devis = await getDocDataByRef(ref);
            setInvoiceData(devis);
          }
          const payments_refs = folder.reglement?.payments || [];
          const payments = await getArrayDocDataByRef(payments_refs);
          setPayments(payments);
          setFolderData(folder);
          setReglementData(folder.reglement);
          setMasterData(master);
          if (
            !particulierActivated(folder) &&
            folder.client_type === "architect"
          ) {
            if (payments.length > 0) {
              let paymentData = await getDocDataByRef(payments[0].ref);
              console.warn("paymentData", paymentData);
              if (
                !paymentData.state === "paid" &&
                !paymentData.initiation_secondss
              ) {
                // then you should not try to access the payment page
                setNoAvailablePayment(true);
              } else {
                console.warn("navigate to payment");
                navigateWorkspace("/rapport/" + payments[0].id);
              }
            } else {
              setNoAvailablePayment(true);
            }
          }
        }

        const user = await getUserById(currentUser.uid); // Fetch user by ID using function

        if (path.includes("/imp-portal/") && orgData?.id === master?.id) {
          // then you are in the impersonation mode
        } else if (user) {
          console.warn("This should only be a guest user");
          let path = window.location.pathname;
          console.warn("handleLogout");
          await handleLogout(path);
          return;
        }

        if (type === "devis") {
          const devis_id = item_id;
          const devis = await getDocDataById("devis", devis_id);
          const master = await getOrgDataById(devis.org_id);
          if (devis.folder_ref) {
            const folder = await getDocDataByRef(devis.folder_ref);
            setFolderData(folder);
            const payments_refs = folder.reglement?.payments || [];
            const payments = await getArrayDocDataByRef(payments_refs);
            setPayments(payments);
          }
          setMasterData(master);
          setInvoiceData(devis);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        handleClickVariant("Erreur de récupération des données", "error");
      }
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser, orgData]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !masterData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  // <div className="flex flex-row  max-w-full pl-1 mr-5 text-gray-800 text-h3  bg-neutral-100   rounded-md  border-1   ">
  //{orgData.name}
  // </div>

  return (
    <div className="flex flex-row pointer-events-auto  h-full">
      {!isMobile && (
        <div className="flex flex-col  h-full w-64 min-w-64  p-2 ">
          <div className="flex max-w-full  flex-col h-full bg-neutral-50 rounded-md border-1 border-neutral-200 overflow-y-auto ">
            <div className="flex flex-col pl-5 gap-1 pr-4 max-w-full">
              <div className="flex flex-row gap-3 items-center ml-1 mt-3">
                <Icon1 icon_name="hexagone" size={24}></Icon1>
                <div className="text-black select-none text-h2 font-semibold">
                  hexagone <span className="text-shadow_50">particulier</span>
                </div>
              </div>
              <Space y={15} />
              <div className="flex flex-row gap-4 items-center ml-1">
                <div className="text-shadow_50 select-none text-h2 font-semibold"></div>
              </div>
              <Space y={20} />
              {invoiceData && (
                <NavBarButton
                  icon="devis"
                  isActualPage={location.pathname.includes("invoice-sign")}
                  onClick={() =>
                    navigateWorkspace("/invoice-sign/" + invoiceData.id)
                  }
                >
                  Devis
                </NavBarButton>
              )}
              {folderData && particulierActivated(folderData) && (
                <NavBarButton
                  icon="folder"
                  isActualPage={location.pathname.includes("folderportal")}
                  onClick={() =>
                    navigateWorkspace("/folderportal/" + folderData.id)
                  }
                >
                  Dossier
                </NavBarButton>
              )}

              {!particulierActivated(folderData) &&
                folderData?.client_type === "architect" &&
                payments?.filter(
                  (payment) =>
                    payment.state === "paid" || payment.initiation_seconds
                ).length === 0 && (
                  <div className="flex flex-row  gap-3 items-center ml-1 border-l-2 border-red-400 pl-2 bg-red-50 rounded-md">
                    <Icon1 icon_name="warning" size={20} fill="red"></Icon1>
                    <div className="select-none text-h4 text-shadow_50 ">
                      Aucun paiement disponible
                    </div>{" "}
                  </div>
                )}

              {payments
                ?.filter(
                  (payment) =>
                    payment.state === "paid" || payment.initiation_seconds
                )
                .map((payment, index) => (
                  <div key={payment.id}>
                    <NavBarButton
                      icon="payments"
                      isActualPage={location.pathname.includes(
                        "/rapport/" + payment.id
                      )}
                      onClick={() => {
                        navigateWorkspace("/rapport/" + payment.id);
                      }}
                    >
                      Rapports {index + 1}{" "}
                      {payment.state === "paid" && (
                        <Icon1
                          icon_name="done2"
                          size={18}
                          fill="#1be681"
                        ></Icon1>
                      )}
                      {(payment.state === "initiated" ||
                        payment.state === "opened") && (
                        <Icon1
                          icon_name="horloge"
                          size={18}
                          fill="#e86e1b"
                        ></Icon1>
                      )}
                    </NavBarButton>
                  </div>
                ))}

              <Space y={10}></Space>
            </div>
            <div
              onClick={() => handleLogout()}
              className="bg-neutral-100 rounded-lg mt-auto cursor-pointer w-fit ml-2 hover:bg-neutral-200 px-2 py-1 flex flex-row gap-2"
            >
              <Icon1 icon_name="logout" size={20} fill="grey"></Icon1>
              <div className="text-h3 text-shadow_50 font-semibold">
                Déconnexion
              </div>
            </div>
            <div className="flex flex-col justify-end mt-2 w-full ">
              <div
                onClick={() => openCallMenu(masterData.infos.phone)}
                className="flex flex-row hover:shadow-lg cursor-pointer  max-w-full justify-between gap-3 p-2 mx-2 mb-2  items-center rounded-md bg-white border-1 border-neutral-200"
              >
                <div className="flex flex-row gap-3 max-w-full">
                  <div className="min-w-10 h-10 rounded-full bg-white flex justify-center relative">
                    <img
                      className="w-10 h-10 rounded-full object-contain object-center"
                      src={
                        masterData.logo ||
                        "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                      }
                    ></img>
                  </div>
                  <div className="flex flex-col flex-grow max-w-full ">
                    <div className="text-h2 text-black select-none">
                      {masterData.name}
                    </div>
                    <div
                      className="text-h6 text-shadow_50
              text-clip overflow-hidden max-w-24
              "
                    >
                      {masterData.infos.phone}
                    </div>
                  </div>{" "}
                </div>
                <div className="">
                  <Icon1 icon_name="phone" size={20} fill="grey"></Icon1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && (
        <div className="flex flex-col w-screen h-30 min-w-64 bg-white  p-2 ">
          <div className="flex max-w-full  flex-col h-full bg-neutral-50 rounded-md border-1 border-neutral-200 overflow-y-auto ">
            <div className="flex flex-col pl-5 pr-4 max-w-full">
              <Space y={15} />
              <div className="flex flex-row gap-3 items-center ml-1">
                <Icon1 icon_name="hexagone" size={24}></Icon1>
                <div className="text-black select-none text-h2 font-semibold">
                  hexagone
                </div>
              </div>
              <Space y={15} />
              <div className="flex flex-row gap-4 items-center ml-1">
                <div className="text-shadow_50 select-none text-h2 font-semibold"></div>
              </div>
              <Space y={20} />
              {invoiceData && (
                <NavBarButton
                  icon="devis"
                  isActualPage={location.pathname.includes("invoice-sign")}
                  onClick={() =>
                    navigateWorkspace("/invoice-sign/" + invoiceData.id)
                  }
                >
                  Devis
                </NavBarButton>
              )}
              {folderData && (
                <NavBarButton
                  icon="folder"
                  isActualPage={location.pathname.includes("folderportal")}
                  onClick={() =>
                    navigateWorkspace("/folderportal/" + folderData.id)
                  }
                >
                  Dossier
                </NavBarButton>
              )}

              {payments?.map((payment, index) => (
                <div key={payment.id}>
                  <NavBarButton
                    icon="payments"
                    isActualPage={
                      location.pathname === "/rapport/" + payment.id
                    }
                    onClick={() => {
                      navigateWorkspace("/rapport/" + payment.id);
                    }}
                  >
                    Paiement {index + 1}
                  </NavBarButton>
                </div>
              ))}

              <Space y={10}></Space>
            </div>{" "}
            <div className="flex flex-col justify-end  mt-auto w-full ">
              <div
                onClick={() => openCallMenu(masterData.infos.phone)}
                className="flex flex-row hover:shadow-lg cursor-pointer  max-w-full justify-between gap-3 p-2 mx-2 mb-2  items-center rounded-md bg-white border-1 border-neutral-200"
              >
                <div className="flex flex-row gap-3 max-w-full">
                  <div className="min-w-10 h-10 rounded-full bg-primary_l3 flex justify-center relative">
                    <img
                      className="w-10 h-10 rounded-full  "
                      src={
                        masterData.logo ||
                        "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                      }
                    ></img>
                  </div>
                  <div className="flex flex-col flex-grow max-w-full ">
                    <div className="text-h2 text-black select-none">
                      {masterData.name}
                    </div>
                    <div
                      className="text-h6 text-shadow_50
              text-clip overflow-hidden max-w-24
              "
                    >
                      {masterData.infos.phone}
                    </div>
                  </div>{" "}
                </div>
                <div className="">
                  <Icon1 icon_name="phone" size={20} fill="grey"></Icon1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NavPortal;
